import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store";

const VENDOR_KEY = "vendor_id";

function getVendorIdFromStorage(): number | undefined {
  const val = sessionStorage.getItem(VENDOR_KEY);
  return val ? Number(val) : undefined;
}

function setVendorIdInStorage(id: number) {
  sessionStorage.setItem(VENDOR_KEY, String(id));
}

function clearVendorIdFromStorage() {
  sessionStorage.removeItem(VENDOR_KEY);
}

export interface VendorState {
  id: number | undefined;
}

const initialState: VendorState = {
  id: getVendorIdFromStorage(),
};

export const vendorSlice = createSlice({
  name: "vendor",
  initialState,
  reducers: {
    setVendorId: (state, action: PayloadAction<number>) => {
      state.id = action.payload;
      setVendorIdInStorage(action.payload); 
    },
    clearVendorId: (state) => {
      state.id = undefined;
      clearVendorIdFromStorage();
    },
  },
});

export const { setVendorId, clearVendorId } = vendorSlice.actions;

// selectors
export const selectVendorId = (state: RootState) => state.vendor.id;

export default vendorSlice.reducer;
